/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMOsisRuleListItem
 */
export interface BCMOsisRuleListItem {
    /**
     * 
     * @type {string}
     * @memberof BCMOsisRuleListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BCMOsisRuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BCMOsisRuleListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof BCMOsisRuleListItem
     */
    readonly marketingCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BCMOsisRuleListItem
     */
    readonly osIs?: Array<string> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof BCMOsisRuleListItem
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleListItem
     */
    allowEdit?: boolean;
}

export function BCMOsisRuleListItemFromJSON(json: any): BCMOsisRuleListItem {
    return BCMOsisRuleListItemFromJSONTyped(json, false);
}

export function BCMOsisRuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMOsisRuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : (json['marketingCarriers'] === null ? null : (json['marketingCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'osIs': !exists(json, 'osIs') ? undefined : json['osIs'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function BCMOsisRuleListItemToJSON(value?: BCMOsisRuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'description': value.description,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'allowEdit': value.allowEdit,
    };
}


